import React, { useState } from 'react';
import { FiTrash2 } from 'react-icons/fi';
import SettingsModal from '../../clientSettings/SettingsModal';

interface Props {
    name: string;
    subject: string;
    onClose: () => void;
    onArchive: () => void;
    onDelete: () => void;
}

const CHOICES = [
    { value: 'archive', title: 'Archive it', hint: 'Hidden from the list but kept for your records. Recommended.' },
    { value: 'delete', title: 'Delete permanently', hint: 'Use for privacy requests. Cannot be undone.' },
] as const;

// archive or permanently delete a contact message (spec 423:14121)
const DeleteMessageModal: React.FC<Props> = ({ name, subject, onClose, onArchive, onDelete }) => {
    const [choice, setChoice] = useState<'archive' | 'delete'>('archive');
    return <SettingsModal danger icon={<FiTrash2 />} title="Delete This Message?" sub={`From ${name} — “${subject}”`} onClose={onClose}
        footer={<button type="button" className="btn-danger" onClick={choice === 'archive' ? onArchive : onDelete}>
            <FiTrash2 /> {choice === 'archive' ? 'Archive Message' : 'Delete Permanently'}
        </button>}>
        <div className="options" role="radiogroup" aria-label="Delete or archive">
            {CHOICES.map(c => <button key={c.value} type="button" role="radio" aria-checked={choice === c.value}
                className={`option${choice === c.value ? ' selected' : ''}`} onClick={() => setChoice(c.value)}>
                <span className="radio" />
                <span className="text"><strong>{c.title}</strong><span>{c.hint}</span></span>
            </button>)}
        </div>
    </SettingsModal>;
};

export default DeleteMessageModal;
